import { useCallback } from 'react';
import { useRecoilState } from 'recoil';

import { toastState } from '@bo-recoil/common/atom';

const useToast = () => {
  const [toasts, setToasts] = useRecoilState(toastState);

  const removeToast = useCallback(
    (toastID) => setToasts((prev) => prev.filter((toast) => toast.id !== toastID)),
    [setToasts]
  );

  const showToast = useCallback(
    (content, duration = undefined) => {
      const id = String(new Date().getTime());

      setToasts([{ content, duration, id }]);
      setTimeout(() => removeToast(id), 600 + (duration ?? 1500));
    },
    [removeToast, setToasts]
  );

  return { toasts, showToast };
};

export default useToast;
